import React from "react";
import DashboardLayout from "@pma/app/dashboard/layout";
import { BoQDetails } from "@pma/components/financials/boq-details";
import { useParams } from "react-router-dom";

const MainBoQDetailPage = () => {
  const params = useParams();
  const boqId = String(params?.boqId);

  return (
    <DashboardLayout>
      <BoQDetails boqId={boqId} />
    </DashboardLayout>
  );
};

export default MainBoQDetailPage;
